// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__-0LzS","resendInfoText":"OnGoingPaymentBox_resendInfoText__3CH8p"};